import scrollToEl from "common/action-function/scrollToElement";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Banner from "components/organisms/Banner";
import FormDowload from "components/organisms/FormDowload";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";
import { WhatMakeUsDifferentV3 } from "components/organisms/WhatMakeUsDifferent/WhatMakeUsDifferentV3";

const IncorporationCheckListTemplate = ({ dataJson, widthBanner }) => {
  return (
    <>
      <Banner
        minHeightBanner=" min-h-[607px]"
        breadcrumbs={dataJson.breadcrumbs}
        tag={dataJson.tag}
        title={dataJson.title}
        description={dataJson.description}
        titleProps={{
          className: "banner-default-title mb-4 lg:mb-10",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        bgColor={"bg-bbc-country"}
        rightContent={
          <Img
            wrapper={{
              className: `bbc-banner-image-country pb-10 ${
                widthBanner ? widthBanner : ""
              }`,
            }}
            src={`/assets/images${dataJson.banner_image}`}
            className="h-full w-full"
            width={dataJson.banner_image_width || 630}
            height={dataJson.banner_image_height || 452}
            priority={true}
            alt="banner-img"
          />
        }
        leftContent={
          <div className="mb-6 text-center lg:mb-0 lg:text-left">
            <ButtonNew
              href={`#${dataJson.dataFormDowload.id}`}
              as="a"
              className=""
              onClick={(e) => {
                scrollToEl(e, false);
              }}
            >
              Download now
            </ButtonNew>
          </div>
        }
      />

      {dataJson.ebookImage ? (
        <WhatMakeUsDifferentV3
          title={dataJson.whatMakeUsDifferentTitle}
          data={dataJson.dataWhatMakeUsDifferent}
          ebookImage={dataJson.ebookImage}
          className="lg:bbc-F7FAFD bg-bbc-brand-100 pt-10 pb-6 lg:py-[80px]"
        />
      ) : (
        <WhatMakeUsDifferent
          title={dataJson.whatMakeUsDifferentTitle}
          data={dataJson.dataWhatMakeUsDifferent}
          className="lg:bbc-F7FAFD bg-bbc-brand-100 pt-10 pb-6 lg:py-[80px]"
        />
      )}
      <section
        className="relative bg-bbc-terms-policy"
        id={dataJson.dataFormDowload.id}
      >
        <div className="container relative z-10 py-10 lg:py-[100px]">
          <FormDowload
            title={dataJson.dataFormDowload.title || ""}
            description={dataJson.dataFormDowload.description || ""}
            checkboxText={dataJson.dataFormDowload.form.checkboxText || ""}
            apiLink={dataJson.dataFormDowload.form.apiLink || ""}
            triggerName={dataJson.dataFormDowload.form.triggerName || ""}
            contactFromId={dataJson.dataFormDowload.form.contactFromId || ""}
            checkedId={dataJson.dataFormDowload.form.checkedId || ""}
            unCheckId={dataJson.dataFormDowload.form.unCheckId || ""}
          />
        </div>
      </section>
    </>
  );
};

export default IncorporationCheckListTemplate;
